// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { Currency } from '@/currency/api/types';
import { isZeroDecimal } from '@/currency/utilities/validate';
import { Decimal } from 'decimal.js';

const MINUTES_PER_HOUR = 60;

interface TimeRecordTotal {
  total: Currency;
  unroundedAmount: Decimal;
  isRounded: boolean;
}

/** Computes a time record's total the way the database column does. */
export function computeTimeRecordTotal(
  hourlyRate: Currency,
  totalMinutes: number
): TimeRecordTotal {
  // Multiplying before dividing keeps the exact product, and the total
  // rounds half away from zero to the currency's minor unit like the
  // stored total_amount column.
  const unroundedAmount = hourlyRate.amount
    .times(totalMinutes)
    .dividedBy(MINUTES_PER_HOUR);
  const minorUnitDigits = isZeroDecimal(hourlyRate.isoCode) ? 0 : 2;
  const totalAmount = unroundedAmount.toDecimalPlaces(
    minorUnitDigits,
    Decimal.ROUND_HALF_UP
  );

  return {
    total: { amount: totalAmount, isoCode: hourlyRate.isoCode },
    unroundedAmount,
    isRounded: !totalAmount.equals(unroundedAmount),
  };
}
